<template>
  <div class="quiz-paginator-line-component mb-5">
    <div
      v-for="(q, i) in questions"
      :key="i + 'paginator'"
      class="paginator-item mb-3"
      :class="{
        'is-last': i == questions.length - 1
      }"
    >
      <div
        class="circle"
        @click="$emit('go-to', i)"
        :class="{
          answered: index != i && isAnswered(i),
          active: index == i,
          ...getSheetClasses(q, i)
        }"
      >
        <i v-if="index != i && isAnswered(i)" class="icon-check text-light"></i>
        <span v-else>{{ i + 1 }}</span>
      </div>
      <div
        v-if="i < questions.length - 1 && !isMobileEdge(i)"
        :class="`line ${i < index ? 'is-after' : ''}`"
      ></div>
    </div>
  </div>
</template>
<script>
import get from "lodash/get";

export default {
  props: {
    questions: {
      type: Array,
      default: () => {}
    },
    answers: {
      type: Object,
      default: () => {}
    },
    score: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    isMobileEdge(i) {
      return window.innerWidth < 991 && (i + 1) % 4 != 0;
    },
    getSheetClasses(q, i) {
      if (this.score && this.score.quiz_answers.length) {
        return {
          right: this.isRight(q, i),
          wrong: !this.isRight(q, i)
        };
      }

      return {};
    },
    isAnswered(i) {
      return !!this.answers[this.questions[i].id].answer_option;
    },
    isRight(question, i) {
      if (this.score && this.score.quiz_answers.length) {
        const right_alternative = question.answer_options.find(
          a => a.is_right_answer
        );

        const user_answer = get(
          this.answers[this.questions[i].id],
          "answer_option",
          get(this.answers[this.questions[i].id], "answer")
        );
        return user_answer == right_alternative.id;
      }

      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.quiz-paginator-line-component {
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;

  @media screen and (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
  }

  .paginator-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 1;
    width: 115px;

    @media screen and (max-width: 991px) {
      flex: 0 0 25%;
      width: 20px;
      justify-content: center;
    }

    &.is-last {
      width: fit-content;
    }

    .circle {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;

      display: flex;
      align-items: center;
      justify-content: center;

      text-align: center;
      font-family: "Font Awesome 6 Free";
      font-size: 14px;
      font-style: normal;
      font-weight: 900;
      &.active {
      }
      &.answered {
      }
    }

    .number {
      color: var(--Cinza, #8e908f);
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;

      &.active:not(.right):not(.wrong) {
        color: var(--Azul-Escuro-2, #003550);
        font-weight: 700;
      }

      &.answered {
        color: var(--Cinza, #8e908f);
        font-weight: 700;
      }
    }
  }

  .w-responsive-100 {
    @media screen and (min-width: 992px) {
      width: 100%;
    }
  }

  .line {
    width: 100%;
    height: 2.3px;
    background: var(--verso-dark-grey-1, #bebfc7);
    z-index: 0;

    &.is-after {
      background: var(--verso-dark-roxo, #3e56ac);
    }

    @media screen and (max-width: 991px) {
      display: none;
    }
  }
}
</style>
